import { useEffect, useState } from "react"
import { api } from "../../../env"
import Loading from "../../../components/loading"
import ErrorFrame from "../../../components/error"
import { useNavigate } from "react-router-dom"

export default function SimpleProgramStats({programId, isDetailed}) {

    const navigate = useNavigate()

    const [stats, setStats] = useState(undefined)
    const [error, setError] = useState(undefined)

    const round2 = (v) => {
        const n = parseFloat(v)
        if (isNaN(n)) return "-"
        if (n === 0) return "0"
        return n.toFixed(2)
    }

    useEffect(() => fetch(), [programId])

    const fetch = () => {
        setStats(undefined)
        setError(undefined)
        if (!programId) return
        api.get(`programs/${programId}/stats`)
            .then(res => {
                let data = res.data
                setStats([
                    {
                        label: "Total Enrollments",
                        value: data.totalEnrollments
                    },
                    {
                        label: "Avg. Monthly Enrollments",
                        value: round2(data.averageMonthlyEnrollments)
                    },
                    {
                        label: "Total Matches",
                        value: data.totalMatches
                    },
                    {
                        label: "Match Success Rate",
                        value: round2(data.matchSuccessRate * 2)
                    },
                    {
                        label: "Rate of Completed Sessions",
                        value: round2(data.rateOfCompletedSessions)
                    },
                    {
                        label: "Engagement Rate",
                        value: round2(data.engagementRate)
                    }
                ])
            })
            .catch(err => {
                setError(err.message)
            })
    }

    const moreStats = () => navigate('stats')

    return(<div className="card standard-padding-s" style={{gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))'}}>
        {!isDetailed && <div className="flex space-between center gap-xs v-spacer-xs">
            <p className="card-title">Program Statistics</p>
            <button className="outline" onClick={moreStats}>View More</button>
        </div>}
        {error && <ErrorFrame onAction={fetch}/> }
        {!stats && !error && <div className="flex justify-center center w-100">
            <Loading message={'Loading Stats...'}/>
        </div>}
        {stats && <div className="grid" style={{gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))'}}>
            {stats.map(stat => <div className="flex columns center gap-s standard-padding-s">
                <div className="flex gap-xxs">
                    <p className="section-title-m medium">{stat.value}</p>
                    {stat?.unit && <p className="section-title-m neutral light">{stat.unit}</p>}
                </div>
                <p className="card-body">{stat.label}</p>
            </div>)}
        </div>}
    </div>)
}